import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCalculator, FiFileText, FiTrendingUp, FiDollarSign, FiClock } = FiIcons;

const Services = () => {
  const services = [
    {
      icon: FiCalculator,
      title: 'Bookkeeping & Accounting',
      description: 'Complete financial record keeping, transaction categorization, and account reconciliation.',
      features: ['Daily transaction recording', 'Bank reconciliation', 'Accounts payable/receivable']
    },
    {
      icon: FiFileText,
      title: 'QuickBooks Setup & Training',
      description: 'Professional QuickBooks setup, customization, and training for your business needs.',
      features: ['QuickBooks installation', 'Chart of accounts setup', 'User training sessions']
    },
    {
      icon: FiTrendingUp,
      title: 'Financial Reporting',
      description: 'Monthly financial statements, profit & loss reports, and business performance analysis.',
      features: ['Monthly P&L statements', 'Balance sheets', 'Cash flow reports']
    },
    {
      icon: FiDollarSign,
      title: 'Tax Preparation Support',
      description: 'Organize your financial records for tax season and work with your tax preparer.',
      features: ['Tax document organization', 'Year-end reporting', 'CPA coordination']
    },
    {
      icon: FiClock,
      title: 'Ongoing Support',
      description: 'Monthly maintenance, cleanup services, and ongoing financial consultation.',
      features: ['Monthly reviews', 'Cleanup services', 'Financial consultation']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive bookkeeping solutions tailored to your business needs
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              <div className="bg-blue-100 rounded-lg p-3 w-fit mb-6">
                <SafeIcon icon={service.icon} className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="text-center mt-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <a
            href="#contact"
            className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200 inline-block"
          >
            Get a Free Consultation
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;